
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hard/gorilla",
      function () {
        return require("private-next-pages/hard/gorilla/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hard/gorilla"])
      });
    }
  